"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _checkCircle = _interopRequireDefault(require("material-ui/svg-icons/action/check-circle"));
var _moreHoriz = _interopRequireDefault(require("material-ui/svg-icons/navigation/more-horiz"));
var _image = _interopRequireDefault(require("material-ui/svg-icons/image/image"));
var _audiotrack = _interopRequireDefault(require("material-ui/svg-icons/image/audiotrack"));
var _videocam = _interopRequireDefault(require("material-ui/svg-icons/av/videocam"));
var _modeEdit = _interopRequireDefault(require("material-ui/svg-icons/editor/mode-edit"));
var _cloudinaryReact = require("cloudinary-react");
var _CircularProgress = _interopRequireDefault(require("material-ui/CircularProgress"));
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
require("./Card.scss");
var _PopupMenu = _interopRequireDefault(require("../PopupMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var iconButtonStyle = {
  width: 40,
  height: 40,
  padding: 0
};
var iconStyle = {
  width: 24,
  height: 24,
  color: "white"
};
var Card = /*#__PURE__*/function (_Component) {
  _inherits(Card, _Component);
  var _super = _createSuper(Card);
  function Card(props) {
    var _this;
    _classCallCheck(this, Card);
    _this = _super.call(this, props);
    _this.handleSelectClick = _this.handleSelectClick.bind(_assertThisInitialized(_this));
    _this.handleEditClick = _this.handleEditClick.bind(_assertThisInitialized(_this));
    _this.handleExclusiveSelect = _this.handleExclusiveSelect.bind(_assertThisInitialized(_this));
    _this.state = {
      lastClicked: null
      // loading: true
    };
    return _this;
  }
  _createClass(Card, [{
    key: "handleSelectClick",
    value: function handleSelectClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.advancedSelectMode) {
        if (this.props.isCmdPressed) {
          this.props.selectHandler(this.props.id);
        } else if (this.props.isShiftPressed) {
          this.props.shiftSelectHandler(this.props.id);
        } else {
          this.props.exclusiveSelectHandler(this.props.id);
        }
      } else {
        this.props.selectHandler(this.props.id);
      }
    }
  }, {
    key: "handleExclusiveSelect",
    value: function handleExclusiveSelect(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.advancedSelectMode) {
        this.props.selectHandler(this.props.id);
      } else {
        this.props.exclusiveSelectHandler(this.props.id);
      }
    }
  }, {
    key: "getCoordinatesModal",
    value: function getCoordinatesModal(coordY, coordX) {
      var vpW = document.documentElement.clientWidth;
      var vpH = document.documentElement.clientHeight;
      if (coordX > vpW / 2) {
        coordX -= 400;
      }
      if (coordY > vpH / 2) {
        coordY -= 400;
      }
      return {
        top: coordY,
        left: coordX
      };
    }
  }, {
    key: "handleEditClick",
    value: function handleEditClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof this.props.editHandler !== "undefined") {
        var rect = this[this.props.id].getBoundingClientRect();
        var modalCoords = this.getCoordinatesModal(rect.top, rect.left);
        var param = this.props.url ? this.props.url : this.props.id;
        this.props.editHandler(param, modalCoords);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        displayCaption = _this$props.displayCaption,
        captionPosition = _this$props.captionPosition,
        CardContentsComponent = _this$props.CardContentsComponent;
      var captionHeight = !displayCaption && captionPosition === "inside" ? 0 : this.props.captionHeight;
      var cloudPublicId = null;
      if (!this.props.imgSrc && !this.props.cloudPublicId) {
        cloudPublicId = this.props.placeholderImageCloudId;
      } else if (this.props.cloudPublicId) {
        cloudPublicId = this.props.cloudPublicId;
      }

      // Setting up styles
      var cmsCardStyle = {
        height: this.props.imageHeight && !isNaN(captionHeight) ? "".concat(this.props.imageHeight + captionHeight, " px") : "auto",
        background: this.props.backgroundColor
        //'color': this.props.fontColor
      };

      var imgStyle = {
        objectFit: this.props.imageFit
      };
      var positionStyle;
      // convert the captionAlignment into a style to Apply
      // Allows 'left','center','right', 'top-left','top-center','top-right','bottom-left','bottom-center','bottom-right'
      //
      switch (this.props.captionAlignment) {
        case "center":
          positionStyle = {
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            margin: 0,
            textAlign: "center"
          };
          break;
        case "left":
          positionStyle = {
            left: 0,
            bottom: 0,
            top: 0,
            right: "auto",
            textAlign: "left"
          };
          break;
        case "right":
          positionStyle = {
            bottom: 0,
            top: 0,
            left: "auto",
            right: 0,
            textAlign: "right"
          };
          break;
        case "top-center":
          positionStyle = {
            bottom: "auto",
            top: 0,
            left: 0,
            right: 0,
            textAlign: "center"
          };
          break;
        case "top-left":
          positionStyle = {
            bottom: "auto",
            top: 0,
            left: 0,
            right: "auto",
            textAlign: "left"
          };
          break;
        case "top-right":
          positionStyle = {
            bottom: "auto",
            top: 0,
            left: "auto",
            right: 0,
            textAlign: "left"
          };
          break;
        case "bottom-center":
          positionStyle = {
            bottom: 0,
            top: "auto",
            left: 0,
            right: 0,
            textAlign: "center"
          };
          break;
        case "bottom-left":
          positionStyle = {
            bottom: 0,
            top: "auto",
            left: 0,
            right: "auto",
            textAlign: "left"
          };
          break;
        case "bottom-right":
          positionStyle = {
            bottom: 0,
            top: "auto",
            left: "auto",
            right: 0,
            textAlign: "left"
          };
          break;
        default:
          positionStyle = {};
          break;
      }
      var titleStyle = _objectSpread({
        height: this.props.captionHeight,
        background: this.props.titleBackgroundColor,
        color: this.props.titleColor
      }, positionStyle);
      var imgConfig = this.props.assetConfig && Object.getOwnPropertyNames(this.props.assetConfig).length > 0 ? this.props.assetConfig : this.props.config;
      var selectedStyle = {
        outline: "4px solid " + this.props.selectedBorderColor
      };
      var ImageIcon, VideoIcon, AudioIcon;
      if (this.props.convertTypeToIcon) {
        ImageIcon = /*#__PURE__*/_react["default"].createElement(_image["default"], {
          color: "white"
        });
        VideoIcon = /*#__PURE__*/_react["default"].createElement(_videocam["default"], {
          color: "white"
        });
        AudioIcon = /*#__PURE__*/_react["default"].createElement(_audiotrack["default"], {
          color: "white"
        });
      }
      var extension = /(?:\.([^.]+))?$/;
      var videoImageSrc = "";
      if (!this.props.imgSrc) {
        if (cloudPublicId && this.props.cloudName) {
          if (this.props.type === "video" || this.props.assetType === "video") {
            videoImageSrc = "".concat(location.protocol, "//res.cloudinary.com/").concat(this.props.cloudName, "/video/upload/w_400/q_auto/");
            if (imgConfig && imgConfig.posterFrame) {
              videoImageSrc += "so_" + parseFloat(imgConfig.posterFrame, 2) + "/";
            }
            videoImageSrc += "".concat(cloudPublicId, ".jpg");
          }
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(card) {
          _this2[_this2.props.id] = card;
        },
        style: cmsCardStyle,
        className: "cms-card ".concat(this.props.lastSelected === this.props.id ? "last-selected" : "", " ").concat(this.props.selected ? "selected" : "", " ").concat(this.props.selectMode ? "select-mode" : "")
      }, displayCaption && captionPosition === "above" ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "card-title",
        className: "".concat(captionPosition, " title-container"),
        style: titleStyle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.props.title
        }
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        key: "card-overlay",
        className: "card-overlay",
        style: this.props.selected && !displayCaption ? _objectSpread({}, selectedStyle) : {},
        onClick: this.handleSelectClick
      }, this.props.showButtons ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "button-container",
        className: "button-container"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        className: "icon select",
        tooltip: (this.props.selected ? "Deselect " : "Select ") + this.props.itemName,
        onClick: this.handleExclusiveSelect,
        style: iconButtonStyle,
        disableTouchRipple: true,
        tooltipPosition: "bottom-center"
      }, /*#__PURE__*/_react["default"].createElement(_checkCircle["default"], {
        color: "white",
        style: iconStyle
      }))) : null, this.props.showButtons && this.props.moreMenuOptions && /*#__PURE__*/_react["default"].createElement(_PopupMenu["default"], {
        className: "more-options",
        action: function action(value) {
          return _this2.props.handleMoreMenuChange(value, _this2.props.id);
        },
        useIconButton: true
      }, this.props.moreMenuOptions && (0, _map2["default"])(this.props.moreMenuOptions, function (option) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          style: {
            fontSize: 14
          },
          value: option.value,
          primaryText: option.label,
          key: option.value
        });
      })), this.props.showButtons && !this.props.onlySelectMode && (this.props.onlyOneSelected && this.props.selected || !this.props.selectMode) && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        className: "icon edit",
        onClick: this.handleEditClick,
        style: iconButtonStyle,
        disableTouchRipple: true,
        tooltip: "Edit " + this.props.itemName,
        tooltipPosition: "bottom-center"
      }, /*#__PURE__*/_react["default"].createElement(_modeEdit["default"], {
        color: "white",
        style: iconStyle
      })), this.props.showButtons ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "gradient-top",
        className: "gradient-top",
        style: {
          height: this.props.vignetteHeight || "auto"
        }
      }) : null, this.props.showButtons ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "gradient-separator",
        className: "gradient-separator",
        style: {
          height: this.props.vignetteHeight || "auto"
        }
      }) : null), /*#__PURE__*/_react["default"].createElement("div", {
        key: "visible-overlay",
        className: "visible-overlay",
        style: this.props.selected && displayCaption ? _objectSpread(_objectSpread({}, selectedStyle), {}, {
          height: "calc(100% - ".concat(this.props.captionHeight, "px)")
        }) : {
          height: "calc(100% - ".concat(this.props.captionHeight, "px)")
        }
      }, this.props.bottomRightIcons || this.props.bottomLeftIcons || this.props.convertTypeToIcon && this.props.type ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "bottom-icons",
        className: "bottom-icons"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        key: "bottom-icons-left",
        className: "icon-container bottom-icons-left"
      }, this.props.bottomLeftIcons ? /*#__PURE__*/_react["default"].createElement("div", null, this.props.bottomLeftIcons) : null, this.props.convertTypeToIcon && !this.props.bottomLeftIcons ? /*#__PURE__*/_react["default"].createElement("div", null, this.props.type === "video" || this.props.assetType === "video" ? VideoIcon : this.props.type === "audio" || this.props.assetType === "audio" ? AudioIcon : null) : null), this.props.bottomRightIcons ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "bottom-icons-right",
        className: "icon-container bottom-icons-right"
      }, /*#__PURE__*/_react["default"].createElement("div", null, " ", this.props.bottomRightIcons, " ")) : null) : null, this.props.bottomRightIcons || this.props.bottomLeftIcons || this.props.convertTypeToIcon && this.props.type && this.props.type !== "image" ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "gradient-bottom",
        className: "gradient-bottom",
        style: {
          height: this.props.vignetteHeight || "auto"
        }
      }) : null), !CardContentsComponent ? /*#__PURE__*/_react["default"].createElement("div", {
        key: "image-container",
        className: "image-container",
        style: {
          height: this.props.imageHeight || "auto"
        }
      }, this.props.imgSrc ? /*#__PURE__*/_react["default"].createElement("img", {
        src: this.props.imgSrc,
        key: this.props.id,
        role: "presentation",
        style: imgStyle
      }) : cloudPublicId && this.props.cloudName ? this.props.type === "video" || this.props.assetType === "video" ? /*#__PURE__*/_react["default"].createElement("img", {
        src: videoImageSrc,
        style: imgStyle
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: "".concat(location.protocol, "//res.cloudinary.com/").concat(this.props.cloudName, "/image/upload/").concat(imgConfig && imgConfig.cropCoordinates ? "c_crop,h_" + imgConfig.cropCoordinates.height + ",w_" + imgConfig.cropCoordinates.width + ",x_" + imgConfig.cropCoordinates.x + ",y_" + imgConfig.cropCoordinates.y + "/" : "", "f_auto,q_auto,w_").concat(this.props.cloudCropMaxSize, ",c_scale/v1/").concat(cloudPublicId).concat(typeof extension.exec(this.props.filename)[1] !== "undefined" ? "" : ".jpg"),
        style: imgStyle
      }) : null) : /*#__PURE__*/_react["default"].createElement(CardContentsComponent, {
        item: item
      }), !displayCaption && (captionPosition === "below" || captionPosition === "inside") ? null : /*#__PURE__*/_react["default"].createElement("div", {
        key: "title-container-bottom",
        className: "".concat(captionPosition, " title-container"),
        style: titleStyle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.props.title
        }
      })));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.imgSrc && !this.props.cloudPublicId) {
        // this.setState({loading: false});
        // if (typeof this.props.onImageLoaded !== 'undefined') {
        //   this.props.onImageLoaded();
        // }
      }
    }
  }]);
  return Card;
}(_react.Component);
Card.defaultProps = {
  advancedSelectMode: true,
  type: "image",
  displayCaption: true,
  captionPosition: "below",
  captionAlignment: "left",
  selectMode: false,
  captionHeight: 28,
  imageHeight: 180,
  backgroundColor: "#212121",
  // vignetteFromColor: 'rgba(0, 0, 0, 0.38)',
  // vignetteToColor: 'transparent',
  fontColor: "rgba(0, 0, 0, 0.87)",
  vignetteHeight: 85,
  titleBackgroundColor: "#2E2E2E",
  titleColor: "rgba(255, 255, 255, 0.30)",
  selectedBorderColor: "#029bE5",
  showButtons: true,
  imageFit: "contain",
  isCloudinary: false,
  cloudCropMaxSize: 600,
  onlySelectMode: false,
  config: null,
  cloudName: "dgpzfuyzy",
  assetConfig: {}
};
Card.propTypes = {
  // Data
  url: _propTypes["default"].string,
  // URL to pass to the editHandler
  type: _propTypes["default"].string,
  // Card type for formatting options
  imgSrc: _propTypes["default"].string,
  // SRC of the card image
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  // Title of the card to display in the caption - HTML admitted
  subtitle: _propTypes["default"].string,
  config: _propTypes["default"].object,
  // Additional config such as cropping config
  advancedSelectMode: _propTypes["default"].bool,
  // this flag forces the bind between select and exclusiveSelect
  // Select states
  selected: _propTypes["default"].bool,
  selectMode: _propTypes["default"].bool,
  onlyOneSelected: _propTypes["default"].bool,
  lastSelected: _propTypes["default"].string,
  onlySelectMode: _propTypes["default"].bool,
  // Hides the editing pencil icon-button
  // Layout
  captionType: _propTypes["default"].string,
  // Allows 'hover-bottom', 'hover-top','hover-center','under', null
  displayCaption: _propTypes["default"].bool,
  imageHeight: _propTypes["default"].number,
  convertTypeToIcon: _propTypes["default"].bool,
  itemName: _propTypes["default"].string,
  // NAme of the item for tooltips
  bottomLeftIcons: _propTypes["default"].node,
  // A node with icons or components to be injected in the bottom
  bottomRightIcons: _propTypes["default"].node,
  // A node with icons or components to be injected in the bottom
  placeholderImageCloudId: _propTypes["default"].string,
  captionPosition: _propTypes["default"].string,
  // Allows 'over', 'below'
  captionAlignment: _propTypes["default"].string,
  // Allows 'left','center','right', 'top-left','top-center','top-right','bottom-left','bottom-center','bottom-right'
  captionHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  vignetteHeight: _propTypes["default"].number,
  showButtons: _propTypes["default"].bool,
  imageFit: _propTypes["default"].string,
  // How the image fits in the container: options (fill, cover, contain, scale-down, none)
  // Styles
  backgroundColor: _propTypes["default"].string,
  fontColor: _propTypes["default"].string,
  // vignetteFromColor: PropTypes.string,
  // vignetteToColor: PropTypes.string,
  titleBackgroundColor: _propTypes["default"].string,
  titleColor: _propTypes["default"].string,
  selectedBorderColor: _propTypes["default"].string,
  // Action Handlers
  editHandler: _propTypes["default"].func,
  selectHandler: _propTypes["default"].func,
  shiftSelectHandler: _propTypes["default"].func,
  exclusiveSelectHandler: _propTypes["default"].func,
  // Key States
  isCmdPressed: _propTypes["default"].bool,
  isShiftPressed: _propTypes["default"].bool,
  // CLOUDINARY - Configuration
  isCloudinary: _propTypes["default"].bool,
  cloudName: _propTypes["default"].string,
  // Cloudinary Name
  cloudPublicId: _propTypes["default"].string,
  // Cloudinary Public Id
  cloudCropMaxSize: _propTypes["default"].number // Resizing card image when fetching from Cloudinary
  // onImageLoaded: PropTypes.func, // Executes this callback when the image has been loaded
  // allCardsLoaded: PropTypes.bool // Flag that indicates that all cards have been loaded
};
var _default = Card;
exports["default"] = _default;